var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"id":"user_logs_filter"}},[_c('div'),_c('div',{staticClass:"ui segment",style:({
            width: (_vm.filter.is_advanced_mode) ? '100%' : 'auto',
            margin: 0
        })},[_c('Header',{staticClass:"right floated"}),_c('div',{staticClass:"clear"}),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(_vm.filter.is_advanced_mode)?_c('Advanced'):_vm._e()],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }